/* ============================================================
   HORCERY — Header: Shop mega-panel, sticky, mobile menu.
   Vanilla, progressive-enhancement, keyboard + a11y first.
   ============================================================ */
(function () {
  'use strict';

  var activeRoot = null;

  /* Publish the TRUE fixed-header height (announcement bar + pill) so hero,
     editorial and the PDP sticky gallery clear the whole stack, not just the pill. */
  function measureHeader() {
    var group = document.querySelector('.shopify-section-group-header-group')
      || document.querySelector('.hz-header');
    if (!group) return;
    var h = group.offsetHeight;
    if (h) document.documentElement.style.setProperty('--hz-header-h', h + 'px');
  }

  function initHeader(root) {
    if (!root || root.__hzInit) return;
    root.__hzInit = true;
    root.__hzCleanup = [];
    activeRoot = root;

    var bar = root.querySelector('.hz-header__bar');
    var megaLi = root.querySelector('[data-hz-mega]');
    var megaBtn = root.querySelector('[data-hz-mega-btn]');
    var megaPanel = root.querySelector('[data-hz-mega-panel]');
    var burger = root.querySelector('[data-hz-menu-toggle]');
    var mobile = root.querySelector('[data-hz-mobile]');
    var scrim = root.querySelector('[data-hz-mobile-scrim]');

    /* --- Sticky shadow on scroll --- */
    if (bar) {
      var onScroll = function () {
        if (window.scrollY > 8) root.setAttribute('data-stuck', '');
        else root.removeAttribute('data-stuck');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      root.__hzCleanup.push(function () { window.removeEventListener('scroll', onScroll); });
    }

    /* --- Shop mega-panel --- */
    if (megaBtn && megaPanel) {
      megaPanel.hidden = false; // JS present → CSS controls visibility
      var closeTimer = null;

      var openMega = function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        megaPanel.setAttribute('data-open', '');
        megaBtn.setAttribute('aria-expanded', 'true');
      };
      var closeMega = function () {
        megaPanel.removeAttribute('data-open');
        megaBtn.setAttribute('aria-expanded', 'false');
      };
      var scheduleClose = function () {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(closeMega, 120);
      };
      var isOpen = function () { return megaBtn.getAttribute('aria-expanded') === 'true'; };

      // hover (desktop)
      if (megaLi) {
        megaLi.addEventListener('mouseenter', openMega);
        megaLi.addEventListener('mouseleave', scheduleClose);
      }
      megaPanel.addEventListener('mouseenter', openMega);
      megaPanel.addEventListener('mouseleave', scheduleClose);

      // click / touch / keyboard
      megaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        isOpen() ? closeMega() : openMega();
      });

      // keyboard: open with focus, close on ESC, trap loosely
      megaBtn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || (e.key === 'Enter' && !isOpen())) {
          e.preventDefault(); openMega();
          var first = megaPanel.querySelector('a');
          if (first) first.focus();
        }
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen()) { closeMega(); megaBtn.focus(); }
      });
      // close when focus leaves both button and panel
      var onFocusIn = function (e) {
        if (!isOpen()) return;
        if (!megaPanel.contains(e.target) && e.target !== megaBtn && !(megaLi && megaLi.contains(e.target))) {
          closeMega();
        }
      };
      document.addEventListener('focusin', onFocusIn);
      // close on outside click
      var onDocClick = function (e) {
        if (isOpen() && !megaPanel.contains(e.target) && !(megaLi && megaLi.contains(e.target))) closeMega();
      };
      document.addEventListener('click', onDocClick);
      root.__hzCleanup.push(function () {
        document.removeEventListener('focusin', onFocusIn);
        document.removeEventListener('click', onDocClick);
      });
    }

    /* --- Mobile menu --- */
    if (burger && mobile) {
      mobile.hidden = false;
      if (scrim) scrim.hidden = false;

      var openMobile = function () {
        root.setAttribute('data-mobile-open', '');
        mobile.setAttribute('data-open', '');
        if (scrim) scrim.setAttribute('data-open', '');
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        var firstLink = mobile.querySelector('a');
        if (firstLink) setTimeout(function () { firstLink.focus(); }, 50);
      };
      var closeMobile = function () {
        root.removeAttribute('data-mobile-open');
        mobile.removeAttribute('data-open');
        if (scrim) scrim.removeAttribute('data-open');
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      };
      burger.addEventListener('click', function () {
        root.hasAttribute('data-mobile-open') ? closeMobile() : openMobile();
      });
      if (scrim) scrim.addEventListener('click', closeMobile);
      mobile.addEventListener('click', function (e) { if (e.target.closest('a')) closeMobile(); });
      var onMobileKey = function (e) {
        if (!root.hasAttribute('data-mobile-open')) return;
        if (e.key === 'Escape') { closeMobile(); burger.focus(); return; }
        if (e.key !== 'Tab') return;
        // Focus trap: keep Tab / Shift+Tab cycling inside the open panel
        var f = mobile.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!mobile.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      document.addEventListener('keydown', onMobileKey);
      root.__hzCleanup.push(function () { document.removeEventListener('keydown', onMobileKey); });
      // close mobile if resized to desktop
      var onResize = function () {
        if (window.innerWidth >= 990 && root.hasAttribute('data-mobile-open')) closeMobile();
      };
      window.addEventListener('resize', onResize, { passive: true });
      root.__hzCleanup.push(function () { window.removeEventListener('resize', onResize); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hz-header]').forEach(initHeader);
  }

  if (document.readyState !== 'loading') { initAll(); measureHeader(); }
  else document.addEventListener('DOMContentLoaded', function () { initAll(); measureHeader(); });

  window.addEventListener('load', measureHeader);
  window.addEventListener('resize', measureHeader, { passive: true });

  // Theme-editor re-init: tear down the previous header's global listeners first.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-header]');
    if (!el) return;
    if (activeRoot && activeRoot.__hzCleanup) {
      activeRoot.__hzCleanup.forEach(function (fn) { try { fn(); } catch (err) {} });
    }
    el.__hzInit = false;
    initHeader(el);
    measureHeader();
  });
})();
